import styled from '@emotion/styled';
import { tokens, Text, Icon, Tooltip, Popover } from '@hotjar/hotsauce';
import type { IconName, PopoverProps as BasePopoverProps } from '@hotjar/hotsauce';

type PopoverProps = Omit<BasePopoverProps, 'children'>;

export const Container = styled.span`
  align-items: center;
  display: inline-flex;
  width: 100%;
  justify-content: space-between;
`;

export const LeftContainer = styled.span`
  display: inline-flex;
  align-items: center;
`;

export const StyledIcon = styled(Icon)`
  margin-right: ${tokens.spacer.x1pt5};
`;

const PopoverText = styled(Text)`
  border-bottom: 1px dotted ${tokens.color.text_light};
  cursor: help;
`;

export const SmartPanelSpacedText = ({
  leftText,
  leftIcon,
  rightText,
  isDisabled,
  disabledTooltipText,
  popoverProps,
}: {
  leftText: string;
  leftIcon?: IconName;
  rightText: string;
  isDisabled?: boolean;
  disabledTooltipText?: string;
  popoverProps?: PopoverProps;
}): JSX.Element => {
  const color = isDisabled ?? false ? 'text_disabled' : 'text_default';

  return (
    <Container>
      <Tooltip text={disabledTooltipText ?? ''} isDisabled={!(isDisabled ?? false)}>
        <LeftContainer>
          {leftIcon !== undefined && <StyledIcon icon={leftIcon} color={color} />}
          {popoverProps && !(isDisabled ?? false) ? (
            <Popover withCloseButton={false} {...popoverProps}>
              <PopoverText as="span" textColor={color}>
                {leftText}
              </PopoverText>
            </Popover>
          ) : (
            <Text as="span" textColor={color}>
              {leftText}
            </Text>
          )}
        </LeftContainer>
      </Tooltip>
      <Tooltip text={disabledTooltipText ?? ''} isDisabled={!(isDisabled ?? false)}>
        <Text as="span" textColor={color}>
          {rightText}
        </Text>
      </Tooltip>
    </Container>
  );
};
